import React, { useEffect, useState } from "react";
import "./questionBox.css";

export default function QuestionBox({ question }) {
   const [displayedText, setDisplayedText] = useState("");
   const [index, setIndex] = useState(0);

   useEffect(() => {
   if (!question) return;
   setDisplayedText("");
   setIndex(0);
   }, [question]);

   useEffect(() => {
   if (!question || index >= question.text.length) return;

   const timeout = setTimeout(() => {
      setDisplayedText((prev) => prev + question.text[index]);
      setIndex(index + 1);
   }, 30);

   return () => clearTimeout(timeout);
   }, [index, question]);

   if (!question) return null;

   return (
      <>
        <div className="questionImageWrapper">
          {question.image != null && (
            <img
              className="questionBoxImage"
              src={question.image}
              alt="Question Box"
            />
          )}
        </div>
    
        <div className="questionBoxContainer">
          <div className="questionBoxTextContainer">
            <p className="questionBoxHeader">{question.header}</p>
            <p className="questionBoxText">{displayedText.split('\n').map((line, index) => (
                      <span key={index}>
                        {line.split(" ").map((word, i) =>
                          word.startsWith("#") ? (
                            <span key={i} className="hashtag">{word} </span>
                          ) : (
                            word + " "
                          )
                        )}
                        <br />
                      </span>
                    ))}
            </p>
          </div>
        </div>
      </>
    );
}